import React from "react";

const MAP = {
  submitted: { label: "Pending Dispatch", bg: "#FEF3C7", text: "#92400E", border: "#FDE68A" },
  awaiting_estimate: { label: "Collecting Bids", bg: "#FFEDD5", text: "#9A3412", border: "#FED7AA" },
  estimate_submitted: { label: "Estimate In", bg: "#E0F2FE", text: "#075985", border: "#BAE6FD" },
  quote_sent: { label: "Quote Sent", bg: "#E0F2FE", text: "#075985", border: "#BAE6FD" },
  approved: { label: "Approved", bg: "#D1FAE5", text: "#065F46", border: "#A7F3D0" },
  accepted: { label: "Accepted", bg: "#D1FAE5", text: "#065F46", border: "#A7F3D0" },
  in_progress: { label: "In Progress", bg: "#EDE9FE", text: "#5B21B6", border: "#DDD6FE" },
  completed: { label: "Completed", bg: "#DCFCE7", text: "#166534", border: "#BBF7D0" },
  closed: { label: "Settled", bg: "#E2E8F0", text: "#334155", border: "#CBD5E1" },
  rejected: { label: "Rejected", bg: "#FEE2E2", text: "#991B1B", border: "#FECACA" },
};

export default function StatusBadge({ status, testid }) {
  const s = MAP[status] || MAP.submitted;
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold font-mono uppercase tracking-wide"
      style={{ background: s.bg, color: s.text, border: `1px solid ${s.border}` }}
    >
      {s.label}
    </span>
  );
}

export const URGENCY = {
  low: { label: "Low", cls: "bg-slate-100 text-slate-600" },
  normal: { label: "Normal", cls: "bg-sky-100 text-sky-700" },
  high: { label: "High", cls: "bg-orange-100 text-orange-700" },
  emergency: { label: "Emergency", cls: "bg-red-100 text-red-700" },
};
